import { Edit } from "@mui/icons-material";
import { Box, Modal, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { changeProfileGroup, changeProfileUser } from "../../api/user";
import AddPhotoIcon from "../../assets/SVG/addPhotoIcon";
// import EditIcon from "../../assets/SVG/editIcon";
import AcquaintancesInfo from "./pagesProfile/acquaintancesInfo";
import GeneralInformation from "./pagesProfile/generalInformation";
import Equipment from "./pagesProfile/profileGroup/equipment";
import GroupInformation from "./pagesProfile/profileGroup/groupInformation";
import SpecializedInformation from "./pagesProfile/specializedInformation";
import UploadProfile from "./uploadProfile";

export default function ViewProfile({
  show,
  setShow,
  dataMyInfo,
  image,
  setImage,
  view,
  role,
  groupInfo,
  setAvatarPic,
}) {
  const [open, setOpen] = useState(false);
  const [openUploader, setOpenUploader] = useState();
  const [hover, setHover] = useState();
  const [avatarGroup, setAvatarGroup] = useState();
  const navigate = useNavigate();
  // const [image, setImage] = useState();
  // const [dataMyInfo, setDataMyInfo] = useState();

  const handleClose = () => {
    setShow(false);
    setOpen(false);
  };
  useEffect(() => {
    if (show === true) {
      setOpen(true);
    }
  }, [show]);
  const [value, setValue] = useState(0);

  const handleChange = (_, newValue) => {
    setValue(newValue);
  };
  const onChangeValueImage = (event) => {
    const file = event.target.files[0];
    let url = window?.URL?.createObjectURL(file);

    // setImage({ file: file, url: url });
    setOpenUploader(null);
    // if (image) {
    if (groupInfo) {
      let formDataImage = new FormData();
      formDataImage.append("file", file);
      changeProfileGroup(formDataImage)
        .then(() => setAvatarGroup(url))
        .catch((err) => console.log("nashod"));
    } else {
      let formDataImage = new FormData();
      formDataImage.append("file", file);
      changeProfileUser(formDataImage)
        .then(() => {
          setAvatarPic(url);
          setImage({ file: file, url: url });
        })
        .catch((err) => console.log("nashod"));
    }
    // console.log(image);
    // }
  };

  // console.log(image);
  useEffect(() => {
    setAvatarGroup(dataMyInfo?.groupPic);
  }, [dataMyInfo]);
  // useEffect(() => {
  //   getMyInformation()
  //     .then((x) => setDataMyInfo(x))
  //     .catch((z) => console.log(z));
  // }, []);

  return (
    <>
      <UploadProfile
        onChangeValueImage={onChangeValueImage}
        anchorEl={openUploader}
        setAnchorEl={setOpenUploader}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ p: "30px" }}
      >
        <Box
          width="100%"
          height="100%"
          bgcolor="white"
          borderRadius="17px"
          sx={{ ":focus-visible": { outline: "none" } }}
        >
          <Box
            width="100%"
            height="280px"
            borderRadius=" 17px 17px 0px 0px"
            bgcolor="#76AEE8"
          >
            <Box pl="20px" mb="-45px" pt="20px" dir="ltr">
              <Box
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  if (groupInfo) {
                    navigate(`/signin/group?${dataMyInfo.nid}`);
                  } else {
                    navigate("/signin/mujahid?mmd");
                  }
                }}
                width="fit-content"
                display="flex"
                gap="10px"
              >
                <Typography color="white" fontSize={"14px"}>
                  ویرایش فرم مشخصات
                </Typography>
                <Edit sx={{ fill: "white !important " }} />
              </Box>
            </Box>
            <Box display="grid" p="15px" justifyItems="center">
              <Box
                position="relative"
                onClick={(e) => setOpenUploader(e.currentTarget)}
              >
                <img
                  style={{
                    objectFit: "cover",
                    width: "120px",
                    height: "120px",
                    borderRadius: "50%",
                    border: " 1px solid rgba(18, 110, 131, 0.81)",
                    // border: " 1px solid rgba(18, 110, 131, 0.81)",
                  }}
                  onMouseEnter={() => {
                    if (!view) {
                      setHover(true);
                    }
                  }}
                  className="imageHover"
                  src={
                    groupInfo
                      ? view
                        ? dataMyInfo?.groupPic
                        : avatarGroup
                      : view
                        ? dataMyInfo?.pic
                        : image?.url || image
                  }
                />
                {hover && !view && (
                  <Box
                    onMouseLeave={() => {
                      setHover(false);
                    }}
                    width="120px"
                    borderRadius="50%"
                    position="absolute"
                    height="120px"
                    bgcolor="#00000090"
                    display="grid"
                    justifyItems="center"
                    alignContent="center"
                    sx={{ cursor: "pointer", top: "2px" }}
                  >
                    <AddPhotoIcon />
                    <Typography color="white" mt="10px">
                      {"ویرایش عکس"}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Typography fontSize="18px" color="white" mt="10px">
                {dataMyInfo?.name}
              </Typography>
              <Box
                sx={{
                  bgcolor: "#CCE5FF",
                  width: "fit-content",
                  p: "5px 10px",
                  borderRadius: "4px",
                  mt: "10px",
                }}
              >
                {role ? role : groupInfo ? "مسئول گروه" : "جهادگر"}
              </Box>
              {!groupInfo ? (
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  sx={{
                    mt: "10px",
                    "& .MuiTabs-indicator": {
                      bgcolor: "white",
                    },
                  }}
                >
                  <Tab
                    label="مشخصات کلی"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(0)}
                  />
                  <Tab
                    label="اطلاعات تخصصی"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(1)}
                  />
                  <Tab
                    label="اطلاعات آشنایان و امنیت"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(2)}
                  />
                </Tabs>
              ) : (
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  sx={{
                    mt: "10px",
                    "& .MuiTabs-indicator": {
                      bgcolor: "white",
                    },
                  }}
                >
                  <Tab
                    label="اطلاعات مسئول"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(0)}
                  />
                  <Tab
                    label="مشخصات گروه"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(1)}
                  />
                  <Tab
                    label="تجهیزات"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(2)}
                  />
                  <Tab
                    label="بخش‌ها"
                    sx={{ color: "white !important" }}
                    onClick={() => setValue(2)}
                  />
                </Tabs>
              )}
            </Box>
            {dataMyInfo && (
              <>
                {!groupInfo ? (
                  <>
                    {value === 0 && <GeneralInformation {...dataMyInfo} />}
                    {value === 1 && <SpecializedInformation {...dataMyInfo} />}
                    {value === 2 && <AcquaintancesInfo {...dataMyInfo} />}
                  </>
                ) : (
                  <>
                    {value === 0 && <GeneralInformation {...dataMyInfo} />}
                    {value === 1 && <GroupInformation {...dataMyInfo} />}
                    {value === 2 && <Equipment {...dataMyInfo} />}
                  </>
                )}
              </>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
}
